export default __webpack_public_path__ + "static/media/crmDashboard.6a73186e.png";